module.exports = __webpack_public_path__ + "static/media/campus-platform-moduleB-icon15.0f8d5ac9.png";